import React, { useCallback, useEffect, useMemo, useState } from 'react';
import EnhancedTable from 'components/tables/EnhancedTable';
import {
  Box,
  IconButton,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  Button,
  Alert,
  AlertTitle,
  Typography
} from '@mui/material';

import Delete from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useBusinessEntityState, useCoreTableState, useAppState, useHttpApi } from 'state';
import { useSnackbar } from 'notistack';
import { useIsOwner } from 'helpers/rbac';
import LoadingActionButton from 'helpers/LoadingActionButton';
import EditDocType from './EditDocType';

const ActionButtons = ({ original, id, docTypeName }) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const { throwErrorMessage } = useAppState();
  const { deleteDocumentType } = useHttpApi();
  const { fetchAllDocumentTypes } = useBusinessEntityState();

  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };
  const handleEditClose = () => {
    setEditOpen(false);
  };
  const handleEditOpen = () => {
    setEditOpen(true);
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          m: 0,
          p: 0,
          alignItems: 'center'
        }}
      >
        <IconButton
          aria-label="subs detail"
          onClick={() => {
            /*  setEditCurrentIssuerInsurer(original); */
            handleEditOpen();
          }}
        >
          <EditIcon sx={{ fontSize: '2.188rem', m: 0, p: 1, backgroundColor: '#F5F8FA' }} />
        </IconButton>
        <Dialog open={editOpen} onClose={handleEditClose} aria-labelledby="alert-dialog-title">
          <DialogContent sx={{ m: 3 }}>
            <EditDocType handleEditClose={handleEditClose} original={original} />
          </DialogContent>
        </Dialog>
        <IconButton aria-label="subs detail" onClick={handleOpen}>
          <Delete sx={{ fontSize: '2.188rem', p: 1, backgroundColor: '#F5F8FA' }} />
        </IconButton>
      </Box>
      <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title">
        <Alert severity="warning">
          <AlertTitle>Delete Document Type</AlertTitle>
          <DialogContent>
            Are you sure you want to delete Document Type, {docTypeName}?
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleClose}
              sx={{ width: '6.7rem' }}
            >
              Cancel
            </Button>
            <LoadingActionButton
              variant="outlined"
              color="error"
              loadingPosition="start"
              sx={{ width: '6.7rem' }}
              onClick={async () => {
                try {
                  console.log(id);
                  const res = await deleteDocumentType(id);
                  enqueueSnackbar('Document Type deleted successfully', {
                    variant: 'success'
                  });
                  await fetchAllDocumentTypes();
                } catch (e) {
                  throwErrorMessage(e);
                }
                handleClose();
              }}
            >
              Delete
            </LoadingActionButton>
          </DialogActions>
        </Alert>
      </Dialog>
    </>
  );
};

export default function AllDocTypes() {
  const isOwner = useIsOwner();
  const { fetchAllDocumentTypes, allDocumentTypes } = useBusinessEntityState();
  const [data, setData] = useState([]);
  const fetchData = () => {
    const _fetchAllDocumentTypes = async () => {
      await fetchAllDocumentTypes();
    };
    _fetchAllDocumentTypes();
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    setData(allDocumentTypes);
    console.log(allDocumentTypes);
  }, [allDocumentTypes]);

  const headCells = useMemo(
    () => [
      {
        accessor: 'name',
        Header: 'Document Type',
        show: true
      },
      {
        accessor: 'actions',
        Header: 'Actions',
        Cell: ({ row: { original } }) => {
          return <ActionButtons original={original} id={original.id} docTypeName={original.name} />;
        },
        show: isOwner
      }
    ],
    [isOwner]
  );

  return (
    <>
      <EnhancedTable
        tableTitle="Document Types"
        columns={headCells}
        refreshFunction={fetchData}
        data={data}
      />
    </>
  );
}
